"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDayExpiryRepresentationFromTimestamp = exports.getAmountInCurrency = exports.offsetTimestampByDays = exports.getInstrumentType = exports.getDifferenceInDaysBetweenDates = exports.getTimeInYearsBetweenDates = exports.calculateImpliedInterestRate = exports.isLinearPerpetual = exports.getPositionType = exports.getSettlementCurrencyFromInstrumentString = exports.getQuoteCurrencyFromInstrumentString = exports.getBaseCurrencyFromInstrumentString = exports.mergePositions = exports.getOptionInstrumentStrike = exports.getInstrumentExpiry = exports.getOptionType = exports.getPositionCurrency = exports.mergeGraphLines = exports.sumLines = exports.getOptionProperties = exports.getOptionInstrumentProperties = exports.getPositionTimeToExpiryFromInstrumentString = exports.getPositionTimeToExpiryandImpliedR = exports.sanitizeNumber = exports.getExpiryTimestampFromInstrumentString = void 0;
const types_1 = require("../types");
const getPositionUsableValues = (position) => {
    var _a, _b;
    return {
        amount: (_a = position.updatedAmount) !== null && _a !== void 0 ? _a : position.amount,
        averagePrice: (_b = position.updatedAveragePrice) !== null && _b !== void 0 ? _b : position.averagePrice,
    };
};
// TODO: functional tests
const MONTHS_MAP = {
    JAN: `01`,
    FEB: `02`,
    MAR: `03`,
    APR: `04`,
    MAY: `05`,
    JUN: `06`,
    JUL: `07`,
    AUG: `08`,
    SEP: `09`,
    OCT: `10`,
    NOV: `11`,
    DEC: `12`,
};
const getExpiryTimestampFromInstrumentString = (instrument) => {
    if (instrument.includes("PERP")) {
        // Somewhere around year 2600
        return 20000000000000;
    }
    const parts = instrument.split("-");
    let instrumentDateString = parts[1];
    if (instrumentDateString.length === 6) {
        instrumentDateString = `0${instrumentDateString}`;
    }
    const day = instrumentDateString.substr(0, 2);
    const month = instrumentDateString.substr(2, 3);
    const lastTwoDigitsOfYear = instrumentDateString.substr(5, 2);
    const dateString = `20${lastTwoDigitsOfYear}-${MONTHS_MAP[month]}-${day}T08:00:00Z`;
    return new Date(dateString).getTime();
};
exports.getExpiryTimestampFromInstrumentString = getExpiryTimestampFromInstrumentString;
const sanitizeNumber = (x) => {
    if (x === Number.NEGATIVE_INFINITY) {
        return Number.MIN_SAFE_INTEGER;
    }
    else if (x === Number.POSITIVE_INFINITY) {
        return Number.MAX_SAFE_INTEGER;
    }
    return x;
};
exports.sanitizeNumber = sanitizeNumber;
const getPositionTimeToExpiryandImpliedR = (currentTimestamp, calculationTimestamp, expirationTimestamp, startPrice, endPrice) => {
    const impliedRate = (0, exports.calculateImpliedInterestRate)(currentTimestamp, expirationTimestamp, startPrice, endPrice);
    let timeToExpiry = (0, exports.getTimeInYearsBetweenDates)(calculationTimestamp, expirationTimestamp);
    timeToExpiry = timeToExpiry < 0 ? 0 : timeToExpiry;
    return {
        r: impliedRate,
        t: timeToExpiry,
    };
};
exports.getPositionTimeToExpiryandImpliedR = getPositionTimeToExpiryandImpliedR;
const getPositionTimeToExpiryFromInstrumentString = (instrument, calculationTimestamp) => {
    const expirationTimestamp = (0, exports.getExpiryTimestampFromInstrumentString)(instrument);
    return (0, exports.getTimeInYearsBetweenDates)(calculationTimestamp, expirationTimestamp);
};
exports.getPositionTimeToExpiryFromInstrumentString = getPositionTimeToExpiryFromInstrumentString;
const getOptionInstrumentProperties = (instrument) => {
    const parts = instrument.split("-");
    return {
        strike: parseFloat(parts[2]),
        optionType: parts[3] === "C" ? types_1.OptionType.CALL : types_1.OptionType.PUT,
    };
};
exports.getOptionInstrumentProperties = getOptionInstrumentProperties;
/**
 * @param ticker
 * @param currentTimestamp The moment that we are using for calculating the implied interest rate.
 * @param calculationTimestamp The moment that we are using for calulation
 * @param instrumentName
 * @returns
 */
const getOptionProperties = (ticker, currentTimestamp, calculationTimestamp, instrumentName) => {
    const parts = instrumentName.split("-");
    const expirationTimestamp = (0, exports.getExpiryTimestampFromInstrumentString)(instrumentName);
    const { r, t: timeToExpiry } = (0, exports.getPositionTimeToExpiryandImpliedR)(currentTimestamp, calculationTimestamp, expirationTimestamp, ticker.indexPrice, ticker.underlyingPrice);
    return {
        strike: parseInt(parts[2]),
        optionType: parts[3] === "C" ? types_1.OptionType.CALL : types_1.OptionType.PUT,
        timeToExpiry,
        r,
    };
};
exports.getOptionProperties = getOptionProperties;
const sumLines = (baseLine, lineToBeAdded) => {
    if (baseLine.length === 0) {
        return lineToBeAdded;
    }
    let res = [];
    for (let i = 0; i < baseLine.length; i++) {
        res.push(baseLine[i] + lineToBeAdded[i]);
    }
    return res;
};
exports.sumLines = sumLines;
const mergeGraphLines = (line1, line2, domain = []) => {
    let min = Number.MAX_SAFE_INTEGER;
    let max = Number.MIN_SAFE_INTEGER;
    let values = [];
    for (let i = 0; i < line2.length; i++) {
        const summedIndex = line1.values[i] + line2[i];
        values.push(summedIndex);
        min = Math.min(min, summedIndex);
        max = Math.max(max, summedIndex);
    }
    return {
        values,
    };
};
exports.mergeGraphLines = mergeGraphLines;
const getPositionCurrency = (position) => {
    return position.instrument.split("-")[0];
};
exports.getPositionCurrency = getPositionCurrency;
const getOptionType = (instrument) => {
    const parts = instrument.split("-");
    return parts[3] === "C" ? types_1.OptionType.CALL : types_1.OptionType.PUT;
};
exports.getOptionType = getOptionType;
const getInstrumentExpiry = (instrument) => {
    const parts = instrument.split("-");
    return parts[1];
};
exports.getInstrumentExpiry = getInstrumentExpiry;
const getOptionInstrumentStrike = (instrument) => {
    return parseInt(instrument.split("-")[2]);
};
exports.getOptionInstrumentStrike = getOptionInstrumentStrike;
const mergePositions = (positions) => {
    let res = {};
    for (const position of positions) {
        if (res[position.instrument]) {
            const { amount: posAmount, averagePrice: posAvgPrice } = getPositionUsableValues(position);
            const { amount: resAmount, averagePrice: resAvgprice } = getPositionUsableValues(res[position.instrument]);
            const amount = posAmount + resAmount;
            const averagePrice = (posAmount * posAvgPrice + resAmount * resAvgprice) / amount;
            res[position.instrument] = Object.assign(Object.assign({}, res[position.instrument]), { amount: amount, averagePrice: averagePrice });
        }
        else {
            const { amount: newPositionAmount, averagePrice: newPosAvgPrice } = getPositionUsableValues(position);
            res[position.instrument] = Object.assign(Object.assign({}, position), { amount: newPositionAmount, averagePrice: newPosAvgPrice, updatedAmount: null, updatedAveragePrice: null });
        }
    }
    return Object.keys(res).map((k) => res[k]);
};
exports.mergePositions = mergePositions;
const getBaseCurrencyFromInstrumentString = (instrument) => {
    const parts = instrument.split("-");
    if (instrument.includes("DVOL") || instrument.includes("USDC")) {
        return instrument.split("_")[0];
    }
    return parts[0];
};
exports.getBaseCurrencyFromInstrumentString = getBaseCurrencyFromInstrumentString;
const getQuoteCurrencyFromInstrumentString = (instrument) => {
    if (instrument.includes("USDC")) {
        return types_1.Currency.USDC;
    }
    return types_1.Currency.USD;
};
exports.getQuoteCurrencyFromInstrumentString = getQuoteCurrencyFromInstrumentString;
const getSettlementCurrencyFromInstrumentString = (instrument) => {
    const parts = instrument.split("-");
    if (instrument.includes("USDC")) {
        return types_1.Currency.USDC;
    }
    return parts[0];
};
exports.getSettlementCurrencyFromInstrumentString = getSettlementCurrencyFromInstrumentString;
const getPositionType = (instrument) => {
    return instrument.split("-").length === 4
        ? types_1.PositionType.Option
        : types_1.PositionType.Future;
};
exports.getPositionType = getPositionType;
const isLinearPerpetual = (instrument) => {
    return (instrument.split("_")[1] === "USDC-PERPETUAL" ||
        (0, exports.getInstrumentType)(instrument) === types_1.PositionType.VolatilityFuture);
};
exports.isLinearPerpetual = isLinearPerpetual;
/**
 * Calculates implied interest rate based on the formula Final amount= Start amount * Math.exp(r*t) where t time in years.
 *
 * @param startTime Timestamp of the start of the calculation period
 * @param endTime Timestamp of the end of the calculation period
 * @param startPrice
 * @param endPrice
 * @returns
 */
const calculateImpliedInterestRate = (startTime, endTime, startPrice, endPrice) => {
    return (Math.log(endPrice / startPrice) /
        (0, exports.getTimeInYearsBetweenDates)(startTime, endTime));
};
exports.calculateImpliedInterestRate = calculateImpliedInterestRate;
/**
 *
 * @param startTime
 * @param endTime
 * @returns
 */
const getTimeInYearsBetweenDates = (startTime, endTime) => {
    return (endTime - startTime) / 1000 / 60 / 525600;
};
exports.getTimeInYearsBetweenDates = getTimeInYearsBetweenDates;
/**
 *
 * @param startTime
 * @param endTime
 * @returns
 */
const getDifferenceInDaysBetweenDates = (startTime, endTime) => {
    return (0, exports.getTimeInYearsBetweenDates)(startTime, endTime) * 365;
};
exports.getDifferenceInDaysBetweenDates = getDifferenceInDaysBetweenDates;
/**
 * Idea: change to instruments with regex and mask. Eg: 'xxx_usdc-nnxxxnn' is linear future. It
 * was easy with two types but now this became complicated.
 */
const getInstrumentType = (instrument) => {
    const instrumentParts = instrument.split("-");
    if (instrumentParts.length === 4) {
        return instrumentParts[0].includes("USDC")
            ? types_1.PositionType.LinearOption
            : types_1.PositionType.Option;
    }
    else {
        if (instrument.includes("DVOL")) {
            return types_1.PositionType.VolatilityFuture;
        }
        if (instrument.split("_")[1] === "USDC-PERPETUAL") {
            return types_1.PositionType.LinearPerpetual;
        }
        if (instrument.includes("_USDC")) {
            return types_1.PositionType.LinearFuture;
        }
        return types_1.PositionType.Future;
    }
};
exports.getInstrumentType = getInstrumentType;
/**
 * Helper function to add some offset to a date.
 *
 * @param timestamp
 * @param days
 * @returns
 */
const offsetTimestampByDays = (timestamp, days) => {
    return timestamp + days * 24 * 60 * 60 * 1000;
};
exports.offsetTimestampByDays = offsetTimestampByDays;
const getAmountInCurrency = (position, underlyingPrice) => {
    const positionType = (0, exports.getInstrumentType)(position.instrument);
    if (positionType === types_1.PositionType.Option) {
        return position.amount;
    }
    else {
        return positionType === types_1.PositionType.LinearPerpetual
            ? position.amount
            : position.amount / underlyingPrice;
    }
};
exports.getAmountInCurrency = getAmountInCurrency;
const MONTHS = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
];
const getDayExpiryRepresentationFromTimestamp = (x) => {
    const d = new Date(x);
    const day = d.getDate();
    const month = MONTHS[d.getMonth()];
    const year = `${d.getFullYear()}`.substring(2);
    return `${day}${month}${year}`;
};
exports.getDayExpiryRepresentationFromTimestamp = getDayExpiryRepresentationFromTimestamp;
